import { AxiosResponse } from "axios";
import { apiResponse } from "./ApiResponse";
import { CommonFormatsService } from "../../Services/CommonFormatsService";

export enum RequestResultType {
      Success,
      ConnectionError,
      ClientError,
      ServerError,
      UnknownError
}

export class RequestResult<T> {
      resultType: RequestResultType;
      summaryTitle: string;
      summaryMessage: string;
      timestamp: string;
      result: T | null;

      constructor(
            r?: AxiosResponse<apiResponse<T>>) {

                  if (r instanceof Error) {
                        this.resultType = RequestResultType.ConnectionError;
                        this.summaryTitle = r.message;
                        this.summaryMessage = r.name;
                        this.timestamp = CommonFormatsService.formatClientFallbackDate(r?.data?.timestamp);
                        this.result = null;
                  } else if (r !== undefined && r != null) {
                        this.resultType = this.convertResultType(r.status);
                        this.summaryTitle = this.determineSummaryTitle(this.resultType, r);
                        this.summaryMessage = this.determineSummaryMessage(this.resultType, r);
                        this.timestamp = CommonFormatsService.formatClientFallbackDate(r?.data?.timestamp);
                        this.result = r?.data?.result ?? null;
                  }
      }

      convertResultType(statusCode: number): RequestResultType {
            const successBounds: [number, number] = [100, 299];
            const connectionErrorBounds: [number, number] = [404, 499];
            const clientErrorBounds: [number, number] = [500, 599];
            const serverErrorBounds: [number, number] = [300, 403];
            
            switch(true) {
                  case successBounds[0] <= statusCode && statusCode <= successBounds[1]:
                        return RequestResultType.Success;
                        case clientErrorBounds[0] <= statusCode && statusCode <= clientErrorBounds[1]:
                              return RequestResultType.ClientError;
                  case serverErrorBounds[0] <= statusCode && statusCode <= serverErrorBounds[1]:
                        return RequestResultType.ServerError;
                  case connectionErrorBounds[0] <= statusCode && statusCode <= connectionErrorBounds[1]:
                        return RequestResultType.ConnectionError;
                  default:
                        return RequestResultType.UnknownError;
            }
      }

      determineSummaryTitle(type: RequestResultType, r: AxiosResponse<apiResponse<T>>): string {
            switch(type) {
                  case RequestResultType.Success:
                        return r.data.statusMessage ?? "Undefined success";
                  case RequestResultType.ConnectionError:
                        return r?.data?.statusMessage ?? "Unable to connect";
                  case RequestResultType.ClientError:
                        return r?.data?.statusMessage ?? "Undefined client error";
                  case RequestResultType.ServerError:
                        return r.data.statusMessage ?? "Undefined server error";
                  case RequestResultType.UnknownError:
                        return "Unknown error";
            }
      }

      determineSummaryMessage(type: RequestResultType, r: AxiosResponse<apiResponse<T>>): string {
            switch(type) {
                  case RequestResultType.Success:
                        return r.data.statusMessage ?? "Undefined success result";
                  case RequestResultType.ConnectionError:
                        return r.status + " error: " + r.statusText;
                  case RequestResultType.ClientError:
                        return r?.data?.statusDetails ?? r.status + " error: " + r.statusText;
                  case RequestResultType.ServerError:
                        return r.data.statusDetails ?? r.status + " error: " + r.statusText;
                  case RequestResultType.UnknownError:
                        return r.status + " status code: " + r.statusText;
            }
      }

      changeType<NT>(updatedData: NT): RequestResult<NT> {
            var converted = new RequestResult<NT>();
            converted.resultType = this.resultType;
            converted.summaryTitle = this.summaryTitle;
            converted.summaryMessage = this.summaryMessage;
            converted.timestamp = this.timestamp;
            converted.result = updatedData;
            return converted;
      }

      isSuccess(): boolean {
            return this.resultType == RequestResultType.Success
      }
}